import React from "react";
import { fetchCustomerMessage } from "@limitless/customer/apis/customer-message-api/CustomerMessageAPI";
import { LAST_MESSAGE_KEY } from "@limitless/customer/utils/customer-message-state-engine/CustomerMessageStateConstants";
import { ClientContext } from "@limitless/common/utils";
import { useCustomerContext } from "@limitless/customer/hooks/customer/CustomerContext";

const useSessionMessage = () => {
    const [sessionLastMessage, setSessionLastMessage] = React.useState(null);
    const [sessionLoading, setSessionLoading] = React.useState(true);
    const { updateCustomerKey } = useCustomerContext();

    const removeSessionLastMessage = () => {
        sessionStorage.removeItem(LAST_MESSAGE_KEY);
        setSessionLoading(false);
    };

    React.useEffect(() => {
        if (ClientContext._clearSessionMessage) {
            removeSessionLastMessage();
        }
        try {
            const sessionMessage = JSON.parse(sessionStorage.getItem(LAST_MESSAGE_KEY) || null);
            if (sessionMessage) {
                const { messageId, accessKey } = sessionMessage;

                fetchCustomerMessage(messageId, accessKey, result => {
                    if (!result.hasError) {
                        if (result.accepted || result.expired) {
                            removeSessionLastMessage();
                        } else {
                            setSessionLastMessage(sessionMessage);
                            setSessionLoading(false);
                        }
                        if (ClientContext._customerUtsc && result.customerKey) {
                            updateCustomerKey(result.customerKey);
                        }
                    } else {
                        removeSessionLastMessage();
                    }
                });
            } else {
                setSessionLoading(false);
            }
        } catch {
            setSessionLoading(false);
            removeSessionLastMessage();
        }
    }, []);

    return {
        sessionLastMessage,
        sessionLoading
    };
};

export default useSessionMessage;
